import ControllerPage from './components/ControllerPage.vue';
import CeremoniesPage from './components/CeremoniesPage';
import LoginPage from './components/LoginPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import RegisterPage from './components/RegisterPage.vue';
import ProfilePage from './components/ProfilePage.vue';
import DesignerPage from './components/DesignerPage.vue';
import MusicLibraryPage from './components/MusicLibraryPage.vue';
import VueRouter from 'vue-router';
import UsersOverviewPage from './components/UsersOverviewPage.vue';
import CorporateStylePage from './components/CorporateStylePage.vue';
import EmailTemplatesPage from './components/EmailTemplatesPage.vue';

const routes = [
    {
        path: '/',
        component: CeremoniesPage,
        name: 'ceremonies',
    },
    {
        path: '/ceremonies/:ceremonyId/control',
        component: ControllerPage,
        name: 'ceremony-control',
    },
    {
        path: '/ceremonies/:ceremonyId/design',
        component: DesignerPage,
        name: 'ceremony-design',
    },
    {
        path: '/music-library',
        component: MusicLibraryPage,
        name: 'music-library',
    },
    {
        path: '/corporate-style',
        component: CorporateStylePage,
        name: 'corporate-style',
    },
    {
        path: '/email-templates',
        component: EmailTemplatesPage,
        name: 'email-templates',
    },
    {
        path: '/login',
        component: LoginPage,
        name: 'login',
        meta: {
            guest: true,
        },
    },
    {
        path: '/register',
        component: RegisterPage,
        name: 'register',
        meta: {
            guest: true,
        },
    },
    {
        path: '/profile',
        component: ProfilePage,
        name: 'profile',
    },
    {
        path: '/forgot-password',
        component: ForgotPasswordPage,
        name: 'forgot-password',
        meta: {
            guest: true
        }
    },
    {
        path: '/users',
        component: UsersOverviewPage,
        name: 'users',
    },
];

export const router = new VueRouter({
    routes,
    mode: 'hash',
});

export default router;
